<template>
  <div v-if="flagDisplayBar">

      <h6 class="text-black text-center" style="font-size:12px">{{displayValue}} {{barData.AfterText}}</h6>
      <div v-if="buttonDisplayColor==1">
        <div class="progress progress-mini">
            <div class="progress-bar progress-bar-success" role="progressbar" aria-valuenow="100" aria-valuemin="0" aria-valuemax="100" v-bind:style="{width: actualBarWidth}"></div>
        </div>
      </div>

      <div v-if="buttonDisplayColor==2">
        <div class="progress progress-mini">
            <div class="progress-bar progress-bar-warning" role="progressbar" aria-valuenow="100" aria-valuemin="0" aria-valuemax="100" v-bind:style="{width: actualBarWidth}"></div>
        </div>
      </div>

      <div v-if="buttonDisplayColor==3">
        <div class="progress progress-mini">
            <div class="progress-bar progress-bar-danger" role="progressbar" aria-valuenow="100" aria-valuemin="0" aria-valuemax="100" v-bind:style="{width: actualBarWidth}"></div>
        </div>
      </div>

  </div>


</template>

<script>

import _ from 'underscore'
import {mapState, mapGetters} from 'vuex'

export default {
  props: ['barParameters'], //{PreviousText, Value, Max, AfterText}

  data() {
    return {
      tempoBundle : {},
      actualBarWidth : '',
      actualPourcentage : 0,
      displayValue : 0,
      barData : {},
      flagDisplayBar : true,
      buttonDisplayColor : 1, //1 : Success, 2: Warning, 3:Danger
    }
  },
  computed: {
    ...mapState('sessionStore', ['actualBundleChannelMaximums','actualBundle']),
  },
  watch: {
    actualBundleChannelMaximums(){
      this.computeColorDisplay()
    },


  },
  methods: {
  
//this.actualBundle.channels[this.channelIndex].ChannelData.lastMeasure['5min'],MAType

   computeColorDisplay(){
      this.flagDisplayBar = false
      this.buttonDisplayColor = 1
      this.barData.AfterText = 'W'
      if (this.barParameters.type == 'CHN'){this.barData.Value = this.actualBundle.channels[this.barParameters.index].ChannelData.lastMeasure[this.barParameters.MAType]}
      if (this.barParameters.type == 'BDL'){this.barData.Value = this.actualBundle.sub_bundle[this.barParameters.index].lastMeasure[this.barParameters.MAType]}
      this.barData.Max = this.actualBundleChannelMaximums[this.barParameters.MAType]
      this.displayValue = this.barData.Value.toFixed(2)
      if (this.barData.Value > 0.70*this.barData.Max){this.buttonDisplayColor = 2}
      if (this.barData.Value > 0.9*this.barData.Max){this.buttonDisplayColor = 3}

      this.actualPourcentage = 100*this.barData.Value/this.barData.Max
      this.actualBarWidth = ''
      this.actualBarWidth = this.actualBarWidth.concat((100*this.barData.Value/this.barData.Max),'%')
      this.flagDisplayBar = true

      },


    },



  mounted() {
    this.computeColorDisplay()

  },



}
</script>

<style lang="css">
</style>



// WEBPACK FOOTER //
// RelativePowerBarMini.vue?8ba1ee26